import TranslatedText from '@sms/plasma-ui/lib/components/TranslatedText/TranslatedText';
import React, { FC } from 'react';

import { IProps } from '../index';

export const SegClassRow: FC<IProps> = ({ statistics }) => {
  return (
    <>
      {statistics && 'segClass' in statistics && (
        <li className="seg__statistics__item">
          <p>
            <TranslatedText textKey="side-menu.segregation-class" />:
          </p>
          <p>{statistics.segClass}</p>
        </li>
      )}
    </>
  );
};

